<form #userForm="ngForm"
      name="userForm"
      class="form-horizontal"
      (ngSubmit)="userForm.valid && submit()">
    <div class="mon-dialog-header">
        <page-header [header]="'Create user' | translate"
                     *ngIf="!user.id"
                     panelClass="row"
                     panelLeftClass="col-48 mt-2">
        </page-header>
        <page-header [header]="'Edit user' | translate"
                     *ngIf="user.id"
                     panelClass="row"
                     panelLeftClass="col-48 mt-2">
        </page-header>
    </div>
    <div class="mon-dialog-body-with-footer pt-3">
        <mon-spinner [progress]="progress">
            <div class="row">
                <div class="col-48 px-12">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h2 class="font-weight-300" translate>User information</h2>
                        </div>
                        <div class="card-body">
                            <form-user-basic [user]="user">
                            </form-user-basic>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-48 px-12">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h2 class="font-weight-300" translate>Visible modules</h2>
                        </div>
                        <div class="card-body">
                            <form-user-access [user]="user">
                            </form-user-access>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-48 px-12">
                    <div class="card panel-monsido-card">
                        <div class="card-header">
                            <h2 class="font-weight-300" translate>Domains</h2>
                        </div>
                        <div class="card-body">
                            <form-user-domains [user]="user">
                            </form-user-domains>

                        </div>
                    </div>
                </div>
            </div>
        </mon-spinner>
    </div>
    <div class="mon-dialog-footer text-right">
        <button type="submit"
                data-test="save-button"
                class="btn btn-border-radius btn-secondary"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: 'user-save'}"
                [disabled]="userForm.invalid"
                translate>
            Save
        </button>
    </div>
</form>
